import { ProductImagesMain } from './product-images-main/product-images-main';
import { ProductImagesThumbs } from './product-images-thumbs/product-images-thumbs';

export class ProductImages {
	private element: HTMLElement;
	private readonly mainElement: HTMLElement;
	private readonly thumbsElement: HTMLElement;
	private mainSlider: ProductImagesMain;
	private thumbsSlider: ProductImagesThumbs;
	private thumbsPrevButton: HTMLButtonElement;
	private thumbsNextButton: HTMLButtonElement;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.mainElement = this.element.querySelector('.product-images-main');
		this.thumbsElement = this.element.querySelector('.product-images-thumbs');
		this.thumbsPrevButton = this.thumbsElement.querySelector('.product-images-thumbs__button--prev');
		this.thumbsNextButton = this.thumbsElement.querySelector('.product-images-thumbs__button--next');

		this.init();
	}

	private handleThumbsPrevButtonClick = (): boolean => this.mainSlider.slider.slidePrev();
	private handleThumbsNextButtonClick = (): boolean => this.mainSlider.slider.slideNext();

	init = (): void => {
		this.thumbsSlider = new ProductImagesThumbs(this.thumbsElement);
		this.mainSlider = new ProductImagesMain(this.mainElement, this.thumbsSlider.slider);
		this.thumbsPrevButton.addEventListener('click', this.handleThumbsPrevButtonClick);
		this.thumbsNextButton.addEventListener('click', this.handleThumbsNextButtonClick);
	};
}
